export const APP_MODES = {
  STAFF: "staff",
  MEMBER: "member",
};

export type APP_MODE = keyof typeof APP_MODES;
